// Course titles come from the `courses` table (English only — see
// src/services/courses.ts) and are shown wherever a course name appears in
// a non-English context: the public Courses listing/detail pages and the
// Become-a-Teacher application form's course picker. Maps each known slug
// to its translated title per locale; a slug not listed here (a new
// course added before this map catches up) falls back to the DB's own
// English title rather than breaking — the DB stays the single source of
// truth for English, this is purely a translation overlay keyed by the
// same stable `slug`.
const COURSE_TITLE: Partial<Record<string, Record<string, string>>> = {
  ur: {
    'noorani-qaida': 'نورانی قاعدہ – قرآن پڑھنے کی بنیاد',
    'fluent-reading': 'روانی سے قرآن پڑھنا',
    'tajweed-basics': 'تجوید کے بنیادی اصول – درست تلاوتِ قرآن',
    'advanced-tajweed': 'اعلیٰ تجوید – اپنی تلاوت میں مہارت حاصل کریں',
    'hifz-program': 'حفظ پروگرام – قرآن حفظ کریں',
    'quran-translation': 'ترجمہ و تفسیر کے ساتھ قرآن',
    'duas-prayers': 'روزانہ کی دعائیں اور ضروری نمازیں',
    'salah-training': 'نماز کی تربیت – صحیح طریقے سے نماز پڑھنا سیکھیں',
    'islamic-basics': 'اسلامی بنیادی معلومات – عقائد و آداب',
  },
  ar: {
    'noorani-qaida': 'نوراني قاعدة – أساس قراءة القرآن',
    'fluent-reading': 'القراءة الطليقة للقرآن',
    'tajweed-basics': 'أساسيات التجويد – تلاوة صحيحة للقرآن',
    'advanced-tajweed': 'التجويد المتقدم – إتقان تلاوتك',
    'hifz-program': 'برنامج الحفظ – حفظ القرآن الكريم',
    'quran-translation': 'القرآن مع الترجمة والتفسير',
    'duas-prayers': 'الأدعية اليومية والصلوات الأساسية',
    'salah-training': 'تدريب الصلاة – تعلم الصلاة بشكل صحيح',
    'islamic-basics': 'أساسيات إسلامية – العقائد والآداب',
  },
  tr: {
    'noorani-qaida': 'Nurani Kaide – Kur’an Okumanın Temeli',
    'fluent-reading': 'Akıcı Kur’an Okuma',
    'tajweed-basics': 'Tecvid Temelleri – Doğru Kur’an Tilaveti',
    'advanced-tajweed': 'İleri Tecvid – Tilavetinizde Ustalaşın',
    'hifz-program': 'Hıfz Programı – Kur’an’ı Ezberleyin',
    'quran-translation': 'Meal ve Tefsirli Kur’an',
    'duas-prayers': 'Günlük Dualar ve Temel Namazlar',
    'salah-training': 'Namaz Eğitimi – Doğru Namaz Kılmayı Öğrenin',
    'islamic-basics': 'İslami Temeller – İnanç ve Adab',
  },
  id: {
    'noorani-qaida': 'Kaidah Nurani – Dasar Membaca Al-Qur’an',
    'fluent-reading': 'Membaca Al-Qur’an dengan Lancar',
    'tajweed-basics': 'Dasar-Dasar Tajwid – Bacaan Al-Qur’an yang Benar',
    'advanced-tajweed': 'Tajwid Lanjutan – Kuasai Bacaan Anda',
    'hifz-program': 'Program Hafalan – Menghafal Al-Qur’an',
    'quran-translation': 'Al-Qur’an dengan Terjemahan & Tafsir',
    'duas-prayers': 'Doa Harian dan Salat Wajib',
    'salah-training': 'Pelatihan Salat – Belajar Salat dengan Benar',
    'islamic-basics': 'Dasar-Dasar Islam – Akidah dan Adab',
  },
}

export function courseTitle(slug: string, dbTitle: string, locale: string): string {
  if (locale === 'en') return dbTitle
  return COURSE_TITLE[locale]?.[slug] ?? dbTitle
}
